export default {
  overrideFields (state, getters, rootState, rootGetters) {
    const mediation = rootGetters['monetization/currentMediation']
    return state.overrideFields[mediation]
  },
  allOverrideFields (state, getters, rootState, rootGetters) {
    return state.overrideFields
  }
}
